<template>
    <div class="FormChangeState">
        <v-row dense>
            <v-col cols="12" md="12" sm="12">
                <div class="custom-state">
                    <v-select :label="'*'+$t('detailChangeStateUser.label.state.title')" :placeholder="$t('detailChangeStateUser.label.state.text')" 
                        required :items="userStatus" item-text="stateName" item-value="stateId" :rules="typeChangeStateRules" color="secondary"
                        v-model="formData.stateId"></v-select>
                </div>
                <div v-if="this.localBlockedByUser !== null && !this.isStateChanged">
                    <h4 class="nombre">{{ $t('detailChangeStateUser.label.responsibleUser') }}</h4>
                    <h4 class="nombre">{{ $t('detailChangeStateUser.label.name') }}:
                        <span class="nombre-claro">{{ this.userAdminId.firstName ? this.userAdminId.firstName + ' ' : ''
                            }}</span>
                        <span class="nombre-claro">{{ this.userAdminId.middleName ? this.userAdminId.middleName + ' ' :
                            '' }}</span>
                        <span class="nombre-claro">{{ this.userAdminId.lastName ? this.userAdminId.lastName + ' ' : ''
                            }}</span>
                        <span class="nombre-claro"> {{ this.userAdminId.secondLastName ? this.userAdminId.secondLastName
                            : '' }}</span>
                    </h4>
                    <h4 class="nombre">{{ $t('detailChangeStateUser.label.email') }}:
                        <span class="nombre-claro">{{ this.userAdminId.emailAddress }}</span>
                    </h4>
                </div>

                <br />
                <v-textarea :label="'*'+$t('label.observation.title')" :placeholder="$t('label.observation.text')" 
                    :counter="200" :maxlength="201" color="secondary" required 
                    :disabled="isSaveButtonDisabled" :rules="messageRules" v-model="localText" outlined>
                </v-textarea>
            </v-col>
            <v-btn large block rounded class="mb-4 custom-btn" color="primary" style="border-radius: 50px;"
                :disabled="isSaveButtonDisabled" @click="submitForm()">
                {{ $t('button.save') }}
            </v-btn>
        </v-row>

    </div>
</template>
<script>

import { mapActions, mapGetters } from "vuex";
import EventBus from "@/utils/event_bus.js";
import i18n from '@/plugins/i18n';
import Swal from "sweetalert2";

import {
    USERSADMIN_M,
    ACTION_GET_USERSTATUS,
    GET_USERSTATUS,
    ACTION_POST_USERSTATUS,
    ACTION_GET_USERSADMIN_ID,
    GET_USER_ADMIN_ID
} from "@/views/users_admin/store/types/types.js";
export default {
    name: "FormChangeState",
    props: {
        dialog: {
            type: Boolean,
        },
        userSt: {
            type: Number,
            required: false,
            default: null,
        },

        isActivo: {
            type: Boolean,
            required: true,
            default: null,
        },
        text: {
            type: String,
            required: false,
            default: null,
        },
        userId: {
            type: Number,
            required: false,
            default: null,
        },
        blockedByUser: {
            type: Number,
            required: false,
            default: null,
        }
    },
    data() {
        return {
            formData: {
                stateId: null,
            },
            previousState: {
                stateId: null,
                text: null,
            },
            localText: this.text,
            localBlockedByUser: this.blockedByUser,
            isSubmitting: false,
            typeChangeStateRules: [(v) => !!v || this.$t('detailChangeStateUser.label.state.required')],
            messageRules: [(v) => !!v || this.$t('label.observation.required')],
            showErrorMessages: false,
        };
    },
    async mounted() {
        await this.getActionUserStatus()
        if (this.userSt) {
            this.formData.stateId = this.userSt;
        }
        if (this.localBlockedByUser !== null) {
            await this.getActionUsersAdminId(this.localBlockedByUser)
        }

    },

    watch: {
        dialog(newVal) {
            if (!newVal) {
                this.formData.stateId = this.userStatus;
            }
        },
        'formData.stateId'(newVal, oldVal) {
            if (newVal !== oldVal) {
                // Solo cuando se cambia de 1 a 2 o de 2 a 1
                if ((newVal === 1 && oldVal === 2) || (newVal === 2 && oldVal === 1)) {
                    // Guardamos el texto actual antes de cambiar el estado
                    this.previousState.text = this.localText;
                    this.localText = null; // Limpiamos el texto
                    this.localBlockedByUser = null; // Limpiamos la propiedad localBlockedByUser
                    this.isStateChanged = true; // Indicamos que el estado ha cambiado
                } else if (newVal === 2 && this.isActivo) {
                    this.localText = this.previousState.text || null;
                }
                this.previousState.stateId = newVal;
            }
        },
    },

    methods: {
        ...mapActions({
            getActionUserStatus: `${USERSADMIN_M}${ACTION_GET_USERSTATUS}`,
            postActionUserStatus: `${USERSADMIN_M}${ACTION_POST_USERSTATUS}`,
            getActionUsersAdminId: `${USERSADMIN_M}${ACTION_GET_USERSADMIN_ID}`,
        }),
        async submitForm() {
            try {
                const result = await Swal.fire({
                    title: i18n.t('label.confirm.title'),
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: i18n.t('button.save.text'),
                    cancelButtonText: i18n.t('button.cancel.text'),
                    confirmButtonColor: '#6E17A5'
                });

                if (result.isConfirmed) {
                    this.isSubmitting = true;
                    const validationErrors = this.validateForm();

                    if (Object.keys(validationErrors).length > 0) {
                        const errorMessages = Object.values(validationErrors).join('<br>');
                        Swal.fire({
                            icon: 'error',
                            title: i18n.t('label.errorsValidation.plural.title'),
                            html: '<div class="swal-subtitle"><b>'+ i18n.t('label.errorsValidation.text') +':</b></div><br>' + errorMessages,
                            confirmButtonColor: '#6E17A5'
                        });
                        return;
                    }
                    let data = {
                        "stateId": this.formData.stateId,
                        "observation": this.localText,
                        "userToBeBlocked": this.userId
                    }

                    const update = await this.postActionUserStatus(data);
                    EventBus.$emit('reload-update-purchaseReconciliation', update.nombre);

                    if (!update) {
                        this.isSubmitting = false;
                        return Swal.fire({
                            icon: 'error',
                            title: i18n.t('label.invalid.title'),
                            text: i18n.t('label.invalid.text')
                        });
                    }
                } else {
                    Swal.fire({
                        position: 'top-end',
                        icon: 'info',
                        title: i18n.t('label.delete.cancel'),
                        showConfirmButton: false,
                        timer: 2500
                    });
                }
            } catch (error) {
                console.error(i18n.t('label.failService'), error);
                this.isSubmitting = false;
            }
        },

        validateForm() {
            this.showErrorMessages = true;
            const errors = {};

            if (!this.formData.stateId) {
                errors.stateId = this.$t('detailChangeStateUser.label.state.title');
            }
            if (!this.localText) {
                errors.text = this.$t('label.observation.title');
            }

            return errors;
        },
    },
    computed: {
        ...mapGetters({
            userStatus: [`${USERSADMIN_M}${GET_USERSTATUS}`],
            userAdminId: [`${USERSADMIN_M}${GET_USER_ADMIN_ID}`],
        }),

        isSaveButtonDisabled() {
            if (this.formData.stateId === 2 && this.isActivo) {
                return true;
            }
            return false;
        }
    },
};
</script>
<style lang="css" scoped>
body {
    font-family: "Nunito Sans", sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6 {
    font-family: "Amsi Pro", sans-serif;
}

img {
    width: 40vh;
}

.password-match-rule-error {
    color: red;
    font-size: 12px;
}

.custom-btn {
    border-radius: 50px;
    padding: 12px;
}

.custom-text {
    font-size: 16px;
    color: #000000;
    text-align: center;
    margin: 5px;
}

.nombre {
    font-size: 14px;
    color: #414141;
}

.nombre-claro {
    color: rgb(96, 96, 96);
}

.custom-state {
    color: #6e17a5;
    text-align: start;
    display: flex;
    padding-right: 100px;
}

.custom-archive {
    color: #6e17a5;
    text-align: start;
}

@media screen and (max-width: 900px) {
    .row {
        padding-top: 0vh;
    }
}
</style>